import React, { useState } from "react";
import { useFetchData } from "../../hooks/useFetchData";
import Cardd from "../../ui/Card";
import { TestLanguage } from "../../hooks/testLanguage";
import {
  QueryClient,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  Backdrop,
  Box,
  Button,
  Drawer,
  Fade,
  Modal,
  Select,
  Tab,
  Tooltip,
  Typography,
} from "@mui/material";
import { CiEraser } from "react-icons/ci";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  MdOutlineDirectionsCarFilled,
  MdOutlineHomeWork,
} from "react-icons/md";
import Carddcar from "../../ui/Cardcar";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast } from "react-toastify";

import approvepng from "../../component/images/checkmark.png";
import Drawer2 from "../../component/Drawer2";
import Drawercar from "../Cars/Drawer2";
import { FaEraser } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";

const AdminOrder = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { data } = useFetchData(`${process.env.REACT_APP_API_URL}units`);
  const { data: data3 } = useFetchData(`${process.env.REACT_APP_API_URL}cars`);
  const closeModal = () => {
    setModalIsOpen(false);
  };
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [selectedPoint2, setSelectedPoint2] = useState(null);
  const [value, setValue] = React.useState("1");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [iddeleted, setIddeleted] = useState();
  const [open, setOpen] = React.useState(false);

  /////////////////////////////////////////////////
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  //////////////////////////////////////////////////////
  const handleClose = () => setOpen(false);
  const handleChange2 = (event, newValue) => {
    setValue(newValue);
  };

  const openModal = (data) => {
    console.log("data", data);

    setSelectedPoint(data);
    setModalIsOpen(true);
    console.log("data", data);
  };
  const openModalcar = (data) => {
    console.log("data", data);

    setSelectedPoint2(data);
    setModalIsOpen(true);
    console.log("data", data);
  };
  const handleOpen = (id) => {
    setIddeleted(id);
    console.log("ggg", id);

    setOpen(true);
  };
  const handleSend = () => {
    const token = localStorage.getItem("token")
    async function deletePost() {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}units/${iddeleted}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // هنا بتحط التوكن
              Accept: "application/json",       // (اختياري) حسب API
            },
          }
        );

        console.log("✅ Deleted:", response.data);

        toast.success("deleted successfully");
        setOpen(false);
        queryClient.invalidateQueries(["posts", iddeleted]);
      } catch (error) {
        console.error(error);
      }
    }
    deletePost();
  };

  const handleSendcar = () => {
    const token = localStorage.getItem("token")
    async function deletePost() {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}cars/${iddeleted}`, {
          headers: {
            Authorization: `Bearer ${token}`, // هنا بتحط التوكن
            Accept: "application/json",       // (اختياري) حسب API
          },
        }
        );
        console.log(response);
        toast.success("deleted successfully");
        setOpen(false);
        queryClient.invalidateQueries(["posts", iddeleted]);
      } catch (error) {
        console.error(error);
      }
    }
    deletePost();
  };

  const unapprove = async (data) => {
    const token = localStorage.getItem("token")
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}changepoststatus`,
        
        {
          post_id: data.id,
          status: "5",
        },{
          headers: {
            Authorization: `Bearer ${token}`, // التوكن
            Accept: "application/json",       // اختياري
          },
        }
      );
      console.log(response);
      queryClient.invalidateQueries([`${process.env.REACT_APP_API_URL}units`]);
    } catch (error) {
      console.error(error);
    }
  };

  const approve = async (data) => {
    const token = localStorage.getItem("token")
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}changepoststatus`,
        
        {
          post_id: data.id,
          status: "4",
        },{
          headers: {
            Authorization: `Bearer ${token}`, // التوكن
            Accept: "application/json",       // اختياري
          },
        }
      );
      queryClient.invalidateQueries([`${process.env.REACT_APP_API_URL}units`]);
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Box className="container" sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange2} aria-label="lab API tabs example">
            <Tab
              sx={{ fontFamily: "oswald,cairo", fontSize: "16px" }}
              icon={<MdOutlineHomeWork size={24} />}
              label={t("nav.realestate")}
              value="1"
            />
            <Tab
              sx={{ fontFamily: "oswald,cairo", fontSize: "16px" }}
              icon={<MdOutlineDirectionsCarFilled size={24} />}
              label={t("nav.cars")}
              value="2"
            />
          </TabList>
        </Box>
        <TabPanel value="1">
          {" "}
          {(data?.data || []).map((i, index) => (
            <div
              style={{ textAlign: "center", margin: "30px 0px" }}
              className="col-md-3
                             col-sm-6"
              key={i.id || index}
              size={6}
            >
              <div>
                <div
                  style={{
                    height: "50px",
                    backgroundColor:
                      i.post.status.id === 1
                        ? "#f5f5f5"
                        : i.post.status.id === 2
                          ? "#697565"
                          : i.post.status.id === 4
                            ? "#CAE8BD"
                            : "#D2665A",
                    borderRadius: "5px 5px 0 0 ",
                    display: "flex",
                    justifyContent: "space-between",
                    paddingLeft: "8px",
                    alignItems: "center",
                    color: "#000",
                  }}
                >
                  <div
                    className="row"
                    style={{
                      justifyContent: "space-evenly",
                      textAlign: "center",
                    }}
                  >
                    <div className="col-md-4">
                      {" "}
                      <Tooltip
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("drawerUnit.unapprove")}
                          </span>
                        }
                      >
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => unapprove(i.post)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="#232324"
                            class="bi bi-x-circle-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                          </svg>
                        </a>
                      </Tooltip>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <Tooltip
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("drawerUnit.approve")}
                          </span>
                        }
                      >
                        <FaCheckCircle
                          src={approvepng}
                          onClick={() => approve(i.post)}
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <Tooltip
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("drawerUnit.delete")}
                          </span>
                        }
                      >
                        <FaEraser
                          style={{ cursor: "pointer" }}
                          size={24}
                          onClick={() => handleOpen(i.id)}
                        />
                      </Tooltip>
                    </div>
                  </div>

                  <h5 style={{ padding: "8px", margin: "0" }}>
                    {TestLanguage(i.post.status, "name")}
                  </h5>
                </div>
                <Modal
                  aria-labelledby="transition-modal-title"
                  aria-describedby="transition-modal-description"
                  open={open}
                  onClose={handleClose}
                  closeAfterTransition
                  slots={{ backdrop: Backdrop }}
                  slotProps={{
                    backdrop: {
                      timeout: 500,
                    },
                  }}
                >
                  <Fade in={open}>
                    <Box sx={style}>
                      <Typography
                        id="transition-modal-title"
                        variant="h4"
                        component="h2"
                      >
                        are you sure for delete this post???
                      </Typography>
                      <div
                        style={{
                          marginTop: "50px",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="success"
                          sx={{ margin: "5px" }}
                          onClick={handleSend}
                        >
                          ok
                        </Button>
                        <Button
                          variant="outlined"
                          color="error"
                          sx={{ margin: "5px" }}
                          onClick={handleClose}
                        >
                          no
                        </Button>
                      </div>
                    </Box>
                  </Fade>
                </Modal>
              </div>
              <span onClick={() => openModal(i)}>
                <Cardd data={i} />
              </span>
            </div>
          ))}
          {selectedPoint && (
            <Drawer2
              point={selectedPoint?.id}
              isOpen={modalIsOpen}
              onClose={closeModal}
            >
              {/* <h2>{selectedPoint?.name}</h2>
                                   <p>{selectedPoint?.description}</p> */}
              <h2>{TestLanguage(selectedPoint?.offertype, "name")}</h2>
              <h2>{TestLanguage(selectedPoint, "name")}</h2>
              <p>{TestLanguage(selectedPoint, "description")}</p>
            </Drawer2>
          )}
        </TabPanel>
        <TabPanel value="2">
          {" "}
          {(data3?.data || []).map((i, index) => (
            <div
              style={{ textAlign: "center", margin: "30px 0px" }}
              className="col-md-3 col-sm-12"
              key={i.id || index}
              size={6}
            >
              <div>
                <div
                  style={{
                    height: "50px",
                    backgroundColor:
                      i.post.status.id === 1
                        ? "#f5f5f5"
                        : i.post.status.id === 2
                          ? "#697565"
                          : i.post.status.id === 4
                            ? "#CAE8BD"
                            : "#D2665A",
                    borderRadius: "5px 5px 0 0 ",
                    display: "flex",
                    justifyContent: "space-between",
                    paddingLeft: "8px",
                    alignItems: "center",
                    color: "#000",
                  }}
                >
                  <div className="row">
                    <div className="col-md-4">
                      {" "}
                      <Tooltip
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("drawerUnit.unapprove")}
                          </span>
                        }
                      >
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => unapprove(i.post)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="#232324"
                            class="bi bi-x-circle-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                          </svg>
                        </a>
                      </Tooltip>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <Tooltip
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("drawerUnit.approve")}
                          </span>
                        }
                      >
                        <FaCheckCircle
                          src={approvepng}
                          onClick={() => approve(i.post)}
                          style={{ width: "20px", height: "20px", cursor: 'pointer' }}
                        />
                      </Tooltip>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <Tooltip
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("drawerUnit.delete")}
                          </span>
                        }
                      >
                        <FaEraser
                          style={{ cursor: "pointer" }}
                          size={24}
                          onClick={() => handleOpen(i.id)}
                        />
                      </Tooltip>
                    </div>
                  </div>

                  <h5 style={{ padding: "8px", margin: "0" }}>
                    {TestLanguage(i.post.status, "name")}
                  </h5>
                </div>
                <Modal
                  aria-labelledby="transition-modal-title"
                  aria-describedby="transition-modal-description"
                  open={open}
                  onClose={handleClose}
                  closeAfterTransition
                  slots={{ backdrop: Backdrop }}
                  slotProps={{
                    backdrop: {
                      timeout: 500,
                    },
                  }}
                >
                  <Fade in={open}>
                    <Box sx={style}>
                      <Typography
                        id="transition-modal-title"
                        variant="h4"
                        component="h2"
                      >
                        are you sure for delete this post???
                      </Typography>
                      <div
                        style={{
                          marginTop: "50px",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="success"
                          sx={{ margin: "5px" }}
                          onClick={handleSendcar}
                        >
                          ok
                        </Button>
                        <Button
                          variant="outlined"
                          color="error"
                          sx={{ margin: "5px" }}
                          onClick={handleClose}
                        >
                          no
                        </Button>
                      </div>
                    </Box>
                  </Fade>
                </Modal>
              </div>
              <span onClick={() => openModalcar(i)}>
                <Carddcar data={i} />
              </span>
            </div>
          ))}
          {selectedPoint2 && (
            <Drawercar
              point={selectedPoint2?.id}
              isOpen={modalIsOpen}
              onClose={closeModal}
            >
              {/* <h2>{selectedPoint?.name}</h2>
                                                       <p>{selectedPoint?.description}</p> */}
              <h2>{TestLanguage(selectedPoint2?.offertype, "name")}</h2>
              <h2>{TestLanguage(selectedPoint2, "name")}</h2>
              <p>{TestLanguage(selectedPoint2, "description")}</p>
            </Drawercar>
          )}
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default AdminOrder;
